import React from 'react';
import { unescapeHtml } from '../utils/escapeHtmlUtil';

export interface Props {
  text: string;
}

/**
 * 改行付きテキスト
 */
export const TextWithLF: React.FC<Props> = ({ text }) => {
  const separator = /\r\n|\n|<br>|<br\/>|<br \/>|<br><\/br>/;
  const unescapedText = unescapeHtml(text);

  const textWithBold = (str: string) => {
    const results = str.match(/<B>.+?<\/B>|<b>.+?<\/b>/g);
    if (!results) return str;
    return (
      <>
        {str.split(/<B>.+?<\/B>|<b>.+?<\/b>/g).map((s, i) => (
          <React.Fragment key={i}>
            {s}
            <b>
              {results[i]
                ?.replace(/<b>(.*?)<\/b>/g, '$1')
                .replace(/<B>(.*?)<\/B>/g, '$1')}
            </b>
          </React.Fragment>
        ))}
      </>
    );
  };

  return (
    <>
      {unescapedText.split(separator).map((str, idx) => (
        <React.Fragment key={idx}>
          {textWithBold(str)}
          <br />
        </React.Fragment>
      ))}
    </>
  );
};
